<template>
    <ol class="inline-flex items-center space-x-1 md:space-x-3">
        <li v-for="(p, i) in paths" :key="i">
            <div class="flex items-center">
                <i v-if="i" class="icon-chevron_destra text-xs"></i>
                <router-link :to="p" exact-active-class="text-next-orange font-bold no-underline"
                             :class="{'ml-1 md:ml-2': i}"
                             class="underline text-sm hover:text-next-gray-300">{{ p.title }}
                </router-link>
            </div>
        </li>
    </ol>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Paths} from "@/types";

@Options({
    name:'Breadcrumbs',
    props: {
        paths: Array,
    }
})
export default class Breadcrumbs extends Vue {
    paths!: Paths[]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
